import React from "react";
import { Plus, Minus, Users } from "lucide-react";
import { MAX_CHILDREN } from "../../constants/ai-lab-constants";

const ChildrenCounter = ({ numChildren, onChangeChildren }) => {
  return (
    <div className="bg-white p-5 sm:p-6 rounded-3xl flex items-center justify-between border border-gray-200 shadow-2xs text-left">
      <div className="flex items-center gap-3">
        <div className="p-2.5 bg-white rounded-xl shadow-2xs border border-gray-100 text-blue-600">
          <Users className="w-5 h-5" />
        </div>
        <div>
          <span className="font-extrabold text-sm text-gray-800">Number of children to enrol</span>
          <p className="text-[11px] text-gray-500 font-semibold mt-0.5">
            You can register up to {MAX_CHILDREN} children together.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 bg-white border border-gray-200 rounded-xl p-1.5 shadow-2xs">
        <button
          type="button"
          disabled={numChildren <= 1}
          onClick={() => onChangeChildren(numChildren - 1)}
          className="w-7 h-7 rounded-lg bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed border border-gray-150 transition"
        >
          <Minus className="w-3.5 h-3.5" />
        </button>
        <span className="font-black text-base text-gray-900 w-6 text-center">{numChildren}</span>
        <button
          type="button"
          disabled={numChildren >= MAX_CHILDREN}
          onClick={() => onChangeChildren(numChildren + 1)}
          className="w-7 h-7 rounded-lg bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed border border-gray-150 transition"
        >
          <Plus className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default ChildrenCounter;
